var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 17,
    viewBox: "0 0 26 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5295_13764)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.4375 1.275C2.4375 0.936849 2.3091 0.612548 2.08054 0.373439C1.85198 0.13433 1.54198 0 1.21875 0C0.895517 0 0.585524 0.13433 0.356964 0.373439C0.128405 0.612548 0 0.936849 0 1.275V15.725C0 16.0632 0.128405 16.3875 0.356964 16.6266C0.585524 16.8657 0.895517 17 1.21875 17C1.54198 17 1.85198 16.8657 2.08054 16.6266C2.3091 16.3875 2.4375 16.0632 2.4375 15.725V1.275ZM12.7416 2.074C12.9699 2.31306 13.0981 2.63712 13.0981 2.975C13.0981 3.31288 12.9699 3.63694 12.7416 3.876L9.54037 7.225H24.7812C25.1045 7.225 25.4145 7.35933 25.643 7.59844C25.8716 7.83755 26 8.16185 26 8.5C26 8.83815 25.8716 9.16245 25.643 9.40156C25.4145 9.64067 25.1045 9.775 24.7812 9.775H9.54037L12.7416 13.124C12.8614 13.2407 12.9574 13.3815 13.024 13.5379C13.0906 13.6943 13.1264 13.8631 13.1293 14.0343C13.1322 14.2055 13.1021 14.3756 13.0408 14.5343C12.9795 14.6931 12.8883 14.8373 12.7726 14.9584C12.6568 15.0794 12.519 15.1749 12.3672 15.239C12.2155 15.3031 12.0529 15.3346 11.8893 15.3316C11.7256 15.3286 11.5642 15.2911 11.4148 15.2214C11.2653 15.1517 11.1307 15.0513 11.0191 14.926L5.73787 9.401L4.875 8.5L5.73625 7.599L11.0175 2.074C11.1307 1.95552 11.2651 1.86153 11.413 1.7974C11.5609 1.73328 11.7194 1.70027 11.8796 1.70027C12.0397 1.70027 12.1982 1.73328 12.3461 1.7974C12.4941 1.86153 12.6284 1.95552 12.7416 2.074Z",
    fill: "white",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5295_13764"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 17,
    fill: "white",
    transform: "matrix(-1 0 0 1 26 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarIcon);
export default __webpack_public_path__ + "static/media/sidebar-icon.b03f2a56eb9999a365dd6d88b6c1c280.svg";
export { ForwardRef as ReactComponent };